/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
// 通用接口
var base = {
  fakeLogin: '/4a57908632c748b1/index',
  // fakeLogin: '/097c76f03f2e98ba/index', // cjt
  // fakeLogin: '/d814490ac48ef4e5/index',
  login: '/children/account',
  // 登录
  forgetPwd: '/children/account/forgetPwd',
  session: '/session',
  smsvalid: '/sms/valid',
  logout: '/children/account/logout',
  enterprise: '/enterprise',
  invite: '/invite',
  systemsettingByCode: '/systemsetting/getByCode',
  systemsettingloginByCode: '/product/getBatchImgByQRCode',
  // ——————————————————————————————————————————————————————————
  // 废弃接口
  jsapi: '/jsapi/cfg',
  userInfo: '/sessionUser/info',
  getBulidType: '/bulid/list',
  wxconfig: '/weixin/cfg',
  wxImageDownload: '/wxImageDownload'
};

// ——————————————————————————————————————————————————————————
// 废弃接口
var appointment = {
  clue: '/clue',
  clueList: '/clue/list'
};

// 首页
var home = {
  bannerList: '/banner/list',
  serviceList: '/service/list',
  serviceDetail: '/service',
  serviceRecommendList: '/service/recommend/list',
  serviceTypeList: '/service/type/list',
  noticeList: '/notice/list',
  noticeDetail: '/notice',
  user: '/user',
  newHome: '/sms/setting/getAssemblyInfo'
};

// 我的
var mine = {
  address: '/account/address',
  addressList: '/account/address/list',
  updateName: '/children/account/updateName',
  groupList: '/children/account/list',
  updatePwd: '/children/account/updatePwd',
  childAccountDetail: 'children/account/detail',
  updateChildren: 'children/account/updateChildren',
  update: '/update'
};

// 工单
var project = {
  orderBashInfo: '/order/bashInfo',
  appointOrder: '/order',
  projectList: '/event/list',
  projectCount: '/event/count',
  project: '/order',
  customer: '/customer',
  taskOrderList: '/task/order/list',
  taskOrderLinkList: '/task/order/linkList',
  messageList: '/order/message/list',
  message: '/order/message',
  customereval: '/order/eval',
  evalExtFieldForm: '/order/eval/bashInfo',
  orderReceipt: '/order/receipt'
};

// 商城
var mall = {
  categoryList: '/shop/classification/list',
  //分类列表
  subclass: '/shop/classification/getchildenClassificationList',
  //二级分类
  productList: '/shop/product/list',
  //
  addshoppingCart: '/shop/cart/add',
  productDetails: '/shop/product/goodDetail',
  //商品详情
  shoppingCartList: '/shop/cart/list',
  orderList: '/shop/order/list',
  //购物车列表
  updateCar: '/shop/cart/update',
  //更新购物车
  determineOrder: '/shop/order/placeOrder',
  //确定订单
  getContact: '/shop/order/getOrderLinkperson',
  //获取联系人
  Offline: '/shop/order/inApproved',
  //线下转账
  receiptAccount: '/shop/order/getCollectionAccount',
  //收款账号
  orderDetails: '/shop/order/getOrderDetail',
  //订单详情
  orderProductDetails: '/shop/order/getOrderGoods',
  //订单商品
  cancelOrder: '/shop/order/cancelOrder',
  //取消订单
  confirmTheReceiptOfGoods: '/shop/order/confirmReceipt',
  //确认收货
  getTransferInformation: '/shop/transfer/list',
  //获取转账信息
  deleOrder: '/shop/order/deleteOrder',
  //删除订单
  delShowCar: '/shop/cart/delete' //删除购物车
};
export default _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, base), appointment), home), mine), project), mall);